import { DateRangeHandler } from '../../..';
import { getDateAsUTC } from '../../utils/dateUtils';

import {
  EXACT_DATES_OFFSET,
  ONE_WEEK_OFFSET,
  THREE_WEEKS_OFFSET,
  TWO_WEEKS_OFFSET
} from './FlexibleOptions';

const MAX_FLEXIBLE_OFFSET = THREE_WEEKS_OFFSET;

export const getSelectedDaysOffset = (from, to, defaultValue) => {
  if (!from || !to) {
    return defaultValue;
  }
  const fromDate = getDateAsUTC(new Date(from));
  const toDate = getDateAsUTC(new Date(to));
  const daysDifference = DateRangeHandler.getDaysDiff(fromDate, toDate);
  if (daysDifference >= MAX_FLEXIBLE_OFFSET) {
    return MAX_FLEXIBLE_OFFSET;
  }

  const options = [
    EXACT_DATES_OFFSET,
    ONE_WEEK_OFFSET,
    TWO_WEEKS_OFFSET,
    THREE_WEEKS_OFFSET
  ];
  return options.reduce(
    (prev, curr) =>
      prev === null ||
      Math.abs(curr - daysDifference) < Math.abs(prev - daysDifference)
        ? curr
        : prev,
    null
  );
};
